import { useQueryClient } from "@tanstack/react-query";
import SideSheetDrawer from "../../../../../components/SidesheetDrawer";
import {
  INITIAL_EM_CONTACT,
  INITIAL_PATIENT_INSURANCE,
} from "../../../../../constants/provider/patient/add-new-patient/add-new-patient-form";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import { PatientInsurance } from "../../../../../services";
import {
  DEFAULT_UUID_NAME_LIST,
  getValueFromObj,
  transformMultiSelectFrontEndVal,
} from "../../../../../utils/utils";
import UpdatePatientForm from "../../patient/UpdatePatientForm";

interface UpsertEditCheckInPatientProps {
  disclosureHost: DisclosureHost;
  patientData?: any;
}

const UpsertEditCheckInPatient = ({
  disclosureHost,
  patientData,
}: UpsertEditCheckInPatientProps) => {
  // const { patientData }: any = useOutletContext();
  const queryClient = useQueryClient();

  const prefillValues = {
    ...patientData,
    emergencyContacts: patientData?.emergencyContacts?.length
      ? patientData?.emergencyContacts
      : INITIAL_EM_CONTACT,
    patientInsurances: patientData?.patientInsurances?.length
      ? patientData?.patientInsurances.map(
          (singleInsurance: PatientInsurance) => ({
            ...singleInsurance,

            provider:
              singleInsurance?.provider &&
              Object.keys(singleInsurance?.provider)?.length
                ? {
                    value: Object.keys(singleInsurance.provider)?.[0],
                    label: getValueFromObj(singleInsurance.provider),
                  }
                : undefined,
            planId: singleInsurance?.planId
              ? {
                  value: singleInsurance?.planId,
                  label: singleInsurance?.planName,
                }
              : undefined,
            insurancePayer: {
              payerId: {
                value: singleInsurance?.insurancePayer?.payerId,
                label: singleInsurance?.insurancePayer?.payerName ?? "",
              },
            },
          })
        )
      : [INITIAL_PATIENT_INSURANCE],
    languages: transformMultiSelectFrontEndVal(
      DEFAULT_UUID_NAME_LIST,
      patientData?.languages
    ),
  };

  return (
    <SideSheetDrawer
      open={disclosureHost?.opened}
      onClose={disclosureHost?.close}
      title="Edit Patient Details"
      w="840px"
    >
      <UpdatePatientForm
        formHeight="calc(100vh - 180px)"
        closeDrawer={() => {
          queryClient.invalidateQueries({
            queryKey: ["provider-group-patients-list"],
          });
          queryClient.invalidateQueries({
            queryKey: ["patient"],
          });
          disclosureHost?.close();
        }}
        prefillValues={prefillValues as any}
        onCancel={() => disclosureHost?.close()}
      />
    </SideSheetDrawer>
  );
};

export default UpsertEditCheckInPatient;
